var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import AnimateHeight from 'react-animate-height';
import { DataVizMobileToggleButton } from './data-viz-mobile-toggle-button';
import { useLang } from '../hooks/use-lang';
var cls = classNames('data-viz-mobile-main');
export var DataVizMobileMainDefaultProps = {
  isExpanded: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    border-top: 1px solid ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    border-top: 1px solid ", ";\n  "])), theme.COLOR('line-mid'))
});
var ToggleButtonStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var RadarContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-right: ", ";\n    padding-left: ", ";\n    padding: 0 ", " ", " ", ";\n    background: ", ";\n    position: relative;\n  "], ["\n    padding-right: ", ";\n    padding-left: ", ";\n    padding: 0 ", " ", " ", ";\n    background: ", ";\n    position: relative;\n  "])), theme.UNIT(8), theme.UNIT(4), theme.UNIT(8), theme.UNIT(2), theme.UNIT(4), theme.COLOR('bright-warm'))
});
var RadarStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: -", ";\n    background: ", ";\n  "], ["\n    margin-top: -", ";\n    background: ", ";\n  "])), theme.UNIT(2), theme.COLOR('bright-warm'))
});
var ScrollLineStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    border-left: 1px dashed ", ";\n    height: calc(100% - 32px);\n    width: 2px;\n    position: absolute;\n    top: 16px;\n    right: 20px;\n  "], ["\n    border-left: 1px dashed ", ";\n    height: calc(100% - 32px);\n    width: 2px;\n    position: absolute;\n    top: 16px;\n    right: 20px;\n  "])), theme.COLOR('line-mid'))
});
var ScrollLabelStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: ", ";\n    text-transform: uppercase;\n    border-radius: ", ";\n    color: ", ";\n    position: absolute;\n    right: -28px;\n    top: calc(50% - ", ");\n    z-index: 100;\n    line-height: 1.0em;\n    background: ", ";\n    padding: ", " ", ";\n    transform: rotate(-90deg);\n    transform-origin: center center;\n  "], ["\n    font-size: ", ";\n    text-transform: uppercase;\n    border-radius: ", ";\n    color: ", ";\n    position: absolute;\n    right: -28px;\n    top: calc(50% - ", ");\n    z-index: 100;\n    line-height: 1.0em;\n    background: ", ";\n    padding: ", " ", ";\n    transform: rotate(-90deg);\n    transform-origin: center center;\n  "])), theme.FONT_SIZE(12), theme.UNIT(3), theme.COLOR('subtle'), theme.UNIT(6), theme.COLOR('bright-warm'), theme.UNIT(0), theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ToggleButton: styled(DataVizMobileToggleButton)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ToggleButtonStyles),
  RadarContainer: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), RadarContainerStyles),
  ScrollLine: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ScrollLineStyles),
  ScrollLabel: styled.span(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ScrollLabelStyles)
};
export var DataVizMobileMain = function (props) {
  var className = props.className,
    children = props.children,
    toggleButtonProps = __rest(props, ["className", "children"]);
  var _a = __read(React.useState(props.isExpanded), 2),
    isVisible = _a[0],
    setIsVisible = _a[1];
  var t = useLang();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.ToggleButton, __assign({
    isExpanded: isVisible,
    onClick: function () {
      setIsVisible(!isVisible);
    }
  }, toggleButtonProps)), React.createElement(AnimateHeight, {
    duration: 300,
    height: isVisible ? 'auto' : 0
  }, React.createElement(My.RadarContainer, null, React.createElement(My.ScrollLine, null), React.createElement(My.ScrollLabel, null, t('Scroll Page')), children)));
};
DataVizMobileMain.cls = cls;
DataVizMobileMain.defaultProps = DataVizMobileMainDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;